import { doc, serverTimestamp, setDoc } from 'firebase/firestore';
import { db } from '../services/firebase';

export const normalizePhoneKey = (phone = '') => String(phone).replace(/\D/g, '');

const getTrackingRef = (companyId, orderId, phone) => {
  const phoneKey = normalizePhoneKey(phone);
  if (!companyId || !orderId || !phoneKey) return null;
  return doc(db, `companies/${companyId}/publicOrderStatus/${phoneKey}/orders`, orderId);
};

export const buildOrderTrackingPayload = (order, updates = {}) => {
  const phoneKey = normalizePhoneKey(order.customerPhone);

  return {
    companyId: order.companyId || '',
    establishmentId: order.establishmentId || '',
    establishmentName: order.establishmentName || '',
    orderId: order.id || '',
    customerName: order.customerName || '',
    customerPhone: order.customerPhone || '',
    customerPhoneKey: phoneKey,
    table: order.table || '',
    status: order.status || 'new',
    paymentStatus: order.paymentStatus || 'pending',
    totalAmount: Number(order.totalAmount) || 0,
    itemCount: Number(order.itemCount) || 0,
    updatedAt: serverTimestamp(),
    ...updates
  };
};

export const syncOrderTracking = async (companyId, order, updates = {}) => {
  const trackingRef = getTrackingRef(companyId, order.id, order.customerPhone);
  if (!trackingRef) return;

  await setDoc(trackingRef, buildOrderTrackingPayload(order, updates), { merge: true });
};
